import { InfoIcon } from "../../../components/Icons";

export function MintErrorNotice({ message, code }: { message: string; code?: string | null }) {
  return <div className="modal-blocked" role="alert">
    <InfoIcon />
    <div>
      <p>{message}</p>
      {code ? <details><summary>Error details</summary><p>Error code: <code>{code}</code></p></details> : null}
    </div>
  </div>;
}
